import { IParamsGetReport18 } from 'app/api/report/model/report-18'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { Loading } from 'app/components/common/Loading'
import { formatMoneyWithoutSpace } from 'app/hook'
import { useGetFilterSummaryReport18 } from 'app/react-query/hook/report'
import styled from 'styled-components'
interface IDataItem {
  colorItem: string
  backgroundItem: string
  borderColorItem: string

  title: string
  value?: number
}

const ItemTotal = ({ item }: { item: IDataItem }) => {
  return (
    <BaseCol style={{ flex: 1 }}>
      <ItemWrapper
        $backgroundItem={item?.backgroundItem}
        $borderColorItem={item?.borderColorItem}
        size={8}
      >
        <BaseText
          fontSize="xxxs"
          fontWeight="medium"
          children={item?.title}
          style={{ color: item?.colorItem }}
        />
        <BaseText
          fontSize="xs"
          fontWeight="semibold"
          children={formatMoneyWithoutSpace(item?.value ?? 0)}
        />
      </ItemWrapper>
    </BaseCol>
  )
}

const ItemWrapper = styled(BaseSpace)<{
  $backgroundItem: string
  $borderColorItem: string
}>`
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${props => props?.$borderColorItem};
  background-color: ${props => props?.$backgroundItem};
`

export interface IResponseSummary {
  total?: number
  sumRetailPrice?: number
  sumTotal?: number
  sumDiscountedAmount?: number
  sumDeductedAmount?: number
  sumRebatedAmount?: number
}

export const TotalArea = ({ params }: { params: IParamsGetReport18 }) => {
  const { data: dataInfinity, isLoading } = useGetFilterSummaryReport18(params)

  return (
    <RootWrapper>
      <BaseRow gutter={[16, 8]} align={'middle'} justify={'space-between'}>
        <ItemTotal
          item={{
            backgroundItem: '#F6FEF9',
            colorItem: '#039855',
            borderColorItem: '#039855',
            title: 'Tổng giá niêm yết',
            value: dataInfinity?.sumRetailPrice,
          }}
        />
        <ItemTotal
          item={{
            backgroundItem: '#EFF8FF',
            colorItem: '#1570EF',
            borderColorItem: '#1570EF',
            title: 'Tổng thành tiền',
            value: dataInfinity?.sumTotal,
          }}
        />
        <ItemTotal
          item={{
            backgroundItem: '#EEF4FF',
            colorItem: '#444CE7',
            borderColorItem: '#444CE7',
            title: 'Tổng khấu trừ TT trả góp',
            value: dataInfinity?.sumDeductedAmount,
          }}
        />
        <ItemTotal
          item={{
            backgroundItem: '#FFFCF5',
            colorItem: '#DC6803',
            borderColorItem: '#DC6803',
            title: 'Tổng CKTT trả full',
            value: dataInfinity?.sumRebatedAmount,
          }}
        />
        <ItemTotal
          item={{
            backgroundItem: '#F9FAFB',
            colorItem: '#6D7580',
            borderColorItem: '#E1E7EA',
            title: 'Tổng giá trị giảm theo KM/VC',
            value: dataInfinity?.sumDiscountedAmount,
          }}
        />
      </BaseRow>
      {isLoading ? <Loading size="small" isAbsolute /> : null}
    </RootWrapper>
  )
}

const RootWrapper = styled.div`
  position: relative;
`
